import React, {CSSProperties, useState} from "react";

interface IProps {
  alt: string;
  src: string;
  defaultSrc?: string;
  className?: string;
  style?: CSSProperties;
}

// This component is good to use when there is a chance
// that your image will return a 404 error.
// You can set default image src as param of this component
const ImgWithDefault: React.FC<IProps> = ({alt, src, className, defaultSrc, style = {}}) => {
  const [showImage, setShowImage] = useState<Boolean>(true);
  const [wasError, setWasError] = useState<Boolean>(false);

  const onError = (e: any) => {
    // Get 404 img url error second time
    if (wasError) {
      return;
    }

    // Get 404 img url error first time
    setWasError(true);

    if (defaultSrc) {
      // Change img src
      e.target.onrror = null;
      e.target.src = defaultSrc;
    } else {
      // Remove img tag
      e.target.onrror = null;
      setShowImage(false);
    }
  };

  return (
    <>
      {showImage && <img className={className} src={src} alt={alt} onError={onError} style={style}/>}
    </>
  );
};

export default ImgWithDefault;
